export const CopySvg = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.166 1.66602H1.66602V14.166H3.33268V3.33268H14.166V1.66602ZM17.4993 18.3327L15.416 16.9327L13.3327 18.3327L11.2493 16.9327L9.16602 18.3327L7.08268 16.9327L4.99935 18.3327V4.99935H17.4993V18.3327Z" fill="#ED5E2A"/>
</svg>
)
}
